import React from 'react';
import classNames from 'classnames';
import styles from './Toggle.css';

const sizes = ['small', 'medium', 'large'];

export default function Toggle({ size, className, ...props }) {
  return (
    <input
      className={classNames(
        styles.toggle,
        styles[sizes.includes(size) ? size : 'small'],
        className,
      )}
      type="checkbox"
      {...props}
    />
  );
}
